function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRoberteberhardServiceDesignThemeCustomIconDesign2 = function SvgRoberteberhardServiceDesignThemeCustomIconDesign2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 564 458",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 93.714,
    cy: 241.776,
    r: 24.144,
    style: {
      fill: "#d5c327"
    },
    transform: "matrix(.86979 0 0 .86979 7.488 54.706)"
  }));
};
export { SvgRoberteberhardServiceDesignThemeCustomIconDesign2 as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDU2NCA0NTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoyOyI+CiAgICA8ZyBpZD0iaWNvbiIgdHJhbnNmb3JtPSJtYXRyaXgoMC44Njk3ODcsMCwwLDAuODY5Nzg3LDcuNDg4NCw1NC43MDYxKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iOTMuNzE0IiBjeT0iMjQxLjc3NiIgcj0iMjQuMTQ0IiBzdHlsZT0iZmlsbDpyZ2IoMjEzLDE5NSwzOSk7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";